"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const PT = __importStar(require("prop-types"));
require("nav-frontend-lesmerpanel-style");
const react_collapse_1 = require("react-collapse");
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const classnames_1 = __importDefault(require("classnames"));
const lesmerpanelToggle_1 = __importDefault(require("./lesmerpanelToggle"));
const lesMerPanelCls = (props) => (0, classnames_1.default)("lesMerPanel", props.className, {
    "lesMerPanel--border": props.border,
});
/**
 * Lesmerpanel
 */
class Lesmerpanel extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = (e) => {
            e.preventDefault();
            this.setState({ erApen: !this.state.erApen });
            if (this.state.erApen) {
                this.props.onClose(e);
            }
            else {
                this.props.onOpen(e);
            }
        };
        this.state = { erApen: props.defaultApen };
    }
    render() {
        const _a = this.props, { intro, children, apneTekst, lukkTekst, id = (0, nav_frontend_js_utils_1.guid)() } = _a, other = __rest(_a, ["intro", "children", "apneTekst", "lukkTekst", "id"]);
        const domProps = (0, nav_frontend_js_utils_1.omit)(other, "border", "onOpen", "onClose", "defaultApen", "className");
        return (React.createElement("div", Object.assign({ id: id, className: lesMerPanelCls(this.props) }, domProps),
            intro && React.createElement("div", { className: "lesMerPanel__intro" }, intro),
            React.createElement("div", { className: "lesMerPanel__merContainer" },
                React.createElement(react_collapse_1.UnmountClosed, { isOpened: this.state.erApen },
                    React.createElement("div", { className: "lesMerPanel__mer" }, children))),
            React.createElement(lesmerpanelToggle_1.default, { "aria-controls": id, apneTekst: apneTekst, lukkTekst: lukkTekst, erApen: this.state.erApen, onClick: this.toggle })));
    }
}
Lesmerpanel.defaultProps = {
    defaultApen: false,
    apneTekst: "Åpne",
    lukkTekst: "Lukk",
    onClose: () => { },
    onOpen: () => { },
};
Lesmerpanel.propTypes = {
    /**
     * Hvorvidt panelet initielt er åpent
     */
    defaultApen: PT.bool,
    /**
     * Funksjon som kalles når panelet åpnes
     */
    onOpen: PT.func,
    /**
     * Funksjon som kalles når panelet lukkes
     */
    onClose: PT.func,
    /**
     * Innhold som plasseres før "Åpne"
     */
    intro: PT.node,
    /**
     * Innhold som vises når man klikker på "Åpne"
     */
    children: PT.node.isRequired,
    /**
     * ID til panelet
     */
    id: PT.string,
    /**
     * Tekst som vises for å lukke panelet
     */
    lukkTekst: PT.string.isRequired,
    /**
     * Tekst som vises for å åpne panelet
     */
    apneTekst: PT.string.isRequired,
    /**
     * Egendefinert klassenavn
     */
    className: PT.string,
    /**
     * Hvis komponenten skal brukes på hvit bakgrunn kan denne brukes for å gi den en border
     */
    border: PT.bool,
};
exports.default = Lesmerpanel;
